module.exports = __webpack_public_path__ + "static/img/class_16.c3ba4e8f.jpg";